var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
var CustomvariableComponent = /** @class */ (function () {
    function CustomvariableComponent(data, dialogRef, router, msg, fb) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.router = router;
        this.msg = msg;
        this.fb = fb;
        this.lead_field = '-1';
        this.crm_label = [];
        this.agentfields = [{ fields: "agent_firstname", label: "Agent First Name" }, { fields: "agent_lastname", label: "Agent Last Name" }, { fields: "agent_fullname", label: "Agent Fullname" }, { fields: "agent_contact", label: "Agent Contact" }, { fields: "agent_email", label: "Agent Email" }];
        this.othersfields = [{ fields: "appointment_comments", label: "Appointment Comments" }, { fields: "appointment_date", label: "Appointment Date" }, { fields: "appointment_place", label: "Appointment Place" }, { fields: "appointment_start_time", label: "Appointment Start Time" }, { fields: "appointment_end_time", label: "Appointment End Time" }, { fields: "zoom", label: "ZOOM URL" }, { fields: "reschedule_appointment", label: "Reschedule Appointment" }, { fields: "cancel", label: "Cancel" }];
        this.questionfields = [
            { fields: "uscitizon", label: "Us Citizen" },
            { fields: "worktimezone", label: "Working Time Zone" },
            { fields: "isfelony", label: "Felony" },
            { fields: "previousemployment", label: "Previous Employment Description" },
            { fields: "mostlike", label: "Previous Employment Most Like" },
            { fields: "leastlike", label: "Previous Employment Least Like" },
            { fields: "income", label: "Income" }
        ];
        console.log(data);
    }
    CustomvariableComponent.prototype.ngOnInit = function () {
        this.labData = this.data.crm_lbel;
        console.log(this.labData);
        // var dataa = this.labData.map(t => t.label);
        this.campaign = this.data.campaign;
        for (var index = 0; index < this.labData.length; index++) {
            if (this.labData[index].label == "") {
                continue;
            }
            this.newData = { fields: this.labData[index].fields, label: this.labData[index].label, default: this.labData[index].default };
            this.crm_label.push(this.newData);
            console.log("this.crm_label", this.crm_label);
        }
    };
    CustomvariableComponent.prototype.updateleadscript = function () {
        console.log(this.lead_field);
        this.leadclose({ leadType: this.lead_field });
    };
    CustomvariableComponent.prototype.leadclose = function (sdata) {
        this.dialogRef.close(sdata);
        console.log(sdata);
    };
    CustomvariableComponent.prototype.onDisable = function (event) {
        console.log(event);
        this.currentState = event;
    };
    CustomvariableComponent.prototype.Close = function () {
        this.dialogRef.close();
        console.log("close");
    };
    CustomvariableComponent = __decorate([
        Component({
            selector: 'app-customvariable',
            template: require("./customvariable.component.html"),
            styles: [require("./customvariable.component.css")]
        }),
        __param(0, Inject(MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [Object, MatDialogRef, Router, MatSnackBar, FormBuilder])
    ], CustomvariableComponent);
    return CustomvariableComponent;
}());
export { CustomvariableComponent };
//# sourceMappingURL=customvariable.component.js.map